import React from "react";
import { Box } from "@mui/material";

export function Page({
  page,
  currentPage,
  children,
}: {
  page: string;
  currentPage: string;
  children: React.ReactNode;
}) {
  if (page === currentPage) {
    return <Box sx={{ marginBottom: 2, paddingX: 2 }}>{children}</Box>;
  }
  return null;
}
